import "./instrument";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter } from "react-router";
import { RouterProvider } from "react-router/dom";
import { route as routeLayout } from "./app/layout";
import { route as routeCommonLayout } from "./app/common-layout";
import { route as routeLogin } from "./app/login";
import { route as homeRoute } from "./app/pages/home";
import { route as selectCategoryRoute } from "./app/pages/select-category";
import { route as selectProductRoute } from "./app/pages/select-product";
import { route as successRoute } from "./app/pages/success";
import { route as scanProductRoute } from "./app/pages/scan-product";
import mixpanel from "mixpanel-browser";
import { route as loadProductRoute } from "./app/pages/load-product/layout";
import { route as registerPlayerRoute } from "./app/pages/register-player/name";
import { route as registerPlayerLastNameRoute } from "./app/pages/register-player/last-name";
import { route as registerPlayerPhoneRoute } from "./app/pages/register-player/phone";
import { route as registerPlayerSuccessRoute } from "./app/pages/register-player/success";

mixpanel.init(import.meta.env.VITE_MIXPANEL_TOKEN, {
  track_pageview: true,
  persistence: "localStorage",
  record_sessions_percent: 100,
  record_heatmap_data: true,
});

import "./index.css";

const router = createBrowserRouter([
  {
    ...routeCommonLayout,
    children: [
      routeLogin,
      {
        ...routeLayout,
        children: [
          homeRoute,
          selectCategoryRoute,
          selectProductRoute,
          successRoute,
          scanProductRoute,
          loadProductRoute,
          registerPlayerRoute,
          registerPlayerLastNameRoute,
          registerPlayerPhoneRoute,
          registerPlayerSuccessRoute,
        ],
      },
    ],
  },
]);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>
);
